import React from "react";
import { FaInstagram } from "react-icons/fa";
import { FaFacebookSquare } from "react-icons/fa";
import { FotCard } from "./FotCard";
import { routes } from "../../Constants/Routes";
import logo from "../../images/logo2.png";
export default function Footerls() {
  return (
    <div className="w-full">
      <FotCard
        logo={<img src={logo} className="h-20 w-40 " />}
        brandName=""
        socialLinks={[
          {
            icon: <FaInstagram className="h-5 w-5" />,
            href: "",
            label: "Instagram",
          },
          {
            icon: <FaFacebookSquare className="h-5 w-5" />,
            href: "",
            label: "Facebook",
          },
        ]}
        mainLinks={[
          // { href: "/products", label: "სერვისები" },
          { href: routes.Home, label: "მთავარი" },
          { href: routes.GetOrder, label: "შეკვეთა" },
        ]}
        // legalLinks={[
        //   { href: "/privacy", label: "Privacy" },
        //   { href: "/terms", label: "Terms" },
        // ]}
        copyright={{
          text: "© 2024 Awesome Corp",
          license: "All rights reserved",
        }}
      />
    </div>
  );
}
